import moment from 'moment';
import { useEffect, useState } from 'react';
import { DateRange } from 'react-date-range';
import Select from 'react-dropdown-select';

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './style.css';

const ALL_TIME_ID = 3
const START_DATE = new Date('2023-06-21')
const DATE_RANGE_OPTIONS = [
  {
    label: '1 Week',
    id: 1,
  },
  {
    label: '1 Month',
    id: 2,
    isDefault: true,
  },
  {
    label: 'All time',
    id: 3,
  },
]

export default function DateRangeSelect({ startDate, endDate, onChange }) {
  const [selectedDateRangeOption, setSelectedDateRangeOption] = useState()
  const [rangeState, setRangeState] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ])

  useEffect(() => {
    setRangeState([
      {
        startDate: startDate,
        endDate: endDate,
        key: 'selection',
      },
    ])
  }, [startDate, endDate])

  const onSelectItem = (option) => {
    const end = new Date()
  
    if (option.id === ALL_TIME_ID) {
      onChange([START_DATE, end])
      setSelectedDateRangeOption(option.id)
      return
    }
  
    const unit = option.id === 1 ? 'week' : 'month'
    const start = moment().subtract(1, unit).toDate()
    setSelectedDateRangeOption(option.id)
    onChange([start, end])
  }

  useEffect(() => {
    let selected = false
    for (const option of DATE_RANGE_OPTIONS) {
      if (option.isDefault) {
        selected = true
        onSelectItem(option)
        break
      }
    }
    if (!selected) {
      onSelectItem(DATE_RANGE_OPTIONS[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onDateRangeChange = (item) => {
    setRangeState([item.selection])
    if (item.selection.startDate === item.selection.endDate) {
      return
    }
    onChange([item.selection.startDate, item.selection.endDate])
  }

  const customContentRenderer = ({ props, state }) => {
    const start = startDate && startDate.toISOString().slice(0, 10)
    const end = endDate && endDate.toISOString().slice(0, 10)
    return (
      <div style={{ cursor: 'pointer' }}>
        {startDate && endDate && `${start} ~ ${end}`}
        {(!startDate || !endDate) && 'All time'}
      </div>
    )
  }

  const customDropdownRenderer = ({ props, state, methods }) => {
    const regexp = new RegExp(state.search, 'i')

    return (
      <div>
        <div className="Date-range-items">
          {DATE_RANGE_OPTIONS.filter((item) =>
            regexp.test(item[props.searchBy] || item[props.labelField])
          ).map((option, index) => {
            if (!props.keepSelectedInList && methods.isSelected(option)) {
              return null
            }

            return (
              <div
                disabled={option.disabled}
                key={index}
                onClick={option.disabled ? null : () => onSelectItem(option)}
                className={
                  option.id === selectedDateRangeOption
                    ? 'Date-range-item selected'
                    : 'Date-range-item'
                }
              >
                <div className="Date-range-item__label">
                  {option[props.labelField]}
                </div>
              </div>
            )
          })}
        </div>
        <div className="Date-range-custom" color={props.color}>
          <DateRange
            editableDateInputs={true}
            onChange={onDateRangeChange}
            moveRangeOnFirstSelection={false}
            ranges={rangeState}
            showDateDisplay={false}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="Date-range-selector-wrapper">
      <Select
        placeholder="Select"
        multi
        contentRenderer={customContentRenderer}
        dropdownRenderer={customDropdownRenderer}
        labelField="label"
        options={DATE_RANGE_OPTIONS}
        closeOnSelect={true}
        closeOnScroll={true}
        values={[selectedDateRangeOption]}
      />
    </div>
  )
}
